import React, { useState } from 'react'

const BonafideCertificate = () => {
  const students = [
    {
      name: "U. Sathvika",
      guardian: "U. Raviteja",
      admission: "252628",
      dob: "09 Feb 2021",
      contact: "7893077007",
      className: "PP-1",
      section: "A"
    },

    {
      name: "Rahul Kumar",
      guardian: "Ramesh Kumar",
      admission: "252629",
      dob: "15 Jan 2020",
      contact: "9876543210",
      className: "1st",
      section: "B"
    }

  ];
  const [search, setSearch] = useState("");
  const [showList, setShowList] = useState(false);
  const [formData, setFormData] = useState({
    certificateType: "Bonafide Certificate",
    academic_year: "",
    curriculum: "",
    className: "",
    section: "",
    student: "",
    fatherName: "",
    admissionNo: "",
    dob: "",
    contactNo: "",
    issueDate: ""
  });

  const filteredStudents = students.filter((item) =>
    item.name.toLowerCase()
      .includes(search.toLowerCase())
  );

  const selectStudent = (student) => {
    setFormData(prev => ({
      ...prev,
      student: student.name,
      fatherName: student.guardian,
      admissionNo: student.admission,
      dob: student.dob,
      contactNo: student.contact,
      // only fill if student has values
      className: student.className || prev.className,
      section: student.section || prev.section
    }));
    setSearch(student.name);
    setShowList(false);
  }

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value

    })
  }

  const displayValue = (value) => {
    return value && value.trim() !== ""
      ? value
      : "________";
  }

  return (
    <>
      <div className='card mt-3'>
        <div className='card-body'>

          <h5 className=''> Generate Certificate </h5>
          <div className="row">
            <div className="col-md-3">
              <label>Academic Year</label>
              <select
                className="form-select"
                name="academic_year"
                value={formData.academic_year}
                onChange={handleChange}
              >
                <option value="">Select</option>
                <option>2026-27</option>
                <option>2025-26</option>
              </select>
            </div>

            <div className="col-md-3">
              <label>Curriculum</label>
              <select
                className="form-select"
                name="curriculum"
                value={formData.curriculum}
                onChange={handleChange}
              >
                <option value="">Select</option>
                <option>SSC</option>
                <option>CBSE</option>
              </select>
            </div>

            <div className="col-md-3">
              <label>Class</label>
              <select
                className="form-select"
                name="className"
                value={formData.className}
                onChange={handleChange}
              >
                <option value="">Select</option>
                <option value="PP-1">PP-1</option>
                <option value="PP-2">PP-2</option>
                <option value="1st">1st</option>
                <option value="2nd">2nd</option>
              </select>
            </div>

            <div className="col-md-3">
              <label>Section</label>
              <select
                className="form-select"
                name="section"
                value={formData.section}
                onChange={handleChange}
              >
                <option value="">Select</option>
                <option value="A">A</option>
                <option value="B">B</option>
              </select>
            </div>

            <div className="col-md-4 position-relative mt-3">
              <label>Search Student</label>
              <input
                className="form-control"
                value={search}
                onChange={(e) => {
                  setSearch(e.target.value);
                  setShowList(true);
                }}
                onFocus={() => setShowList(true)}
              />

              {
                showList && search &&
                <div className="student-dropdown">
                  {
                    filteredStudents.map((stu, index) => (
                      <div
                        key={index}
                        className="student-item"
                        onClick={() => selectStudent(stu)}
                      >
                        <b>{stu.name}</b>
                        <br />
                        <span>
                          Father / Guardian : {stu.guardian}
                        </span>
                      </div>
                    ))
                  }
                </div>
              }
            </div>

            <div className="col-md-4 mt-3">
              <label>Admission No</label>
              <input
                className="form-control"
                value={formData.admissionNo}
                readOnly
              />
            </div>
          </div>

        </div>
      </div>

      <div className="row">
        <div className="col-md-10 offset-md-1">
          <div className="print-certificate">
            <div className="certificate">
              <div className="certificate-border">

                <div className="school-header">
                  <img src="https://www.srinitheplayschool.com/img/logo.png"
                    className="school-logo"
                  />
                  <div>
                    <h2>
                      SRINI THE PLAY SCHOOL & ACADEMY
                    </h2>

                    <p>
                      Vijayawada, Andhra Pradesh
                      <br />
                      Contact : 7893077007
                    </p>
                  </div>
                </div>

                <h1>

                  {formData.certificateType.toUpperCase()}

                </h1>

                <div className="certificate-body">
                  <h6>
                    TO WHOM IT MAY CONCERN
                  </h6>

                  <span>
                    This is to certify that &nbsp;
                    <b>{displayValue(formData.student)}</b>,
                    son/daughter of &nbsp; &nbsp;
                    <b>{formData.fatherName}</b>,
                    bearing Admission No.
                    <b>{displayValue(formData.admissionNo)}</b>,
                    is a bonafide student of  &nbsp;
                    <b>SRINI THE PLAY SCHOOL & ACADEMY</b> &nbsp;
                    currently studying in &nbsp;
                    <b>
                      {displayValue(formData.className)} - {displayValue(formData.section)}
                    </b>


                    &nbsp;  for the academic year &nbsp;

                    <b>
                      {displayValue(formData.academic_year)}
                    </b>.
                  </span>

                  &nbsp;
                  <span>
                    Date of Birth :
                    <b>{displayValue(formData.dob)}</b>
                  </span>

                  {/* <p>
                    Contact No :
                    <b>{displayValue(formData.contactNo)}</b>
                  </p> */}

                  <p>
                    This certificate is issued on the specific request
                    of the student/parent for submission to the concerned
                    authority.
                  </p>
                </div>

                <div className="footer">
                  <div>
                    _________________
                    <br />
                    PRINCIPAL
                  </div>

                  <div className="seal">
                    <br />
                    SEAL
                  </div>

                  <div>
                    _________________
                    <br />
                    Date : {formData.issueDate}
                  </div>
                </div>
              </div>

            </div>
            <div className="no-print text-center">

              <button
                className="btn btn-success mt-3"
                onClick={() => window.print()}
              >
                Print Certificate
              </button>

            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default BonafideCertificate